import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminUsersKeys } from 'app/queries/adminUsers/adminUsersKeys';
import type { TCall } from './types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminUsersKeys.list>>;

export const createFetchAdminUsersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getAdmins({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
        }),
        signal,
      ),
    );
